export default function TextCodeBlock () {
  const BLOCKS = document.querySelectorAll('.mtt-text-code-block__code')
  if (BLOCKS.length > 0) {
    for (let i = 0; i < BLOCKS.length; i++) {
      const BLOCK = BLOCKS[i]
      const BLOCK_INNER = BLOCK.querySelector('.mtt-text-code-block__code-inner')
      const BUTTON = BLOCK.querySelector('.mtt-text-code-block__code-button')

      BUTTON && BUTTON.addEventListener('click', () => {
        BLOCK_INNER.classList.remove('mtt-text-code-block__code-inner--hidden')
        BUTTON.classList.add('hide')
      })
    }
  }
}
